import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW1312Component } from './kymw1312.component';
import { KYMW1313Module } from '../../kymw13/kymw1313/kymw1313.module';
import { GetSetPlanGoodsInfoService } from './api-service/get-set-plan-goods-info.service';
import { GetSetPlanPromotionGoodsInfoService } from './api-service/get-set-plan-promotion-goods-info.service';
import { GetSetPromotionNoService } from './api-service/get-set-promotion-no.service';
import { RegistSetPlanPromotionGoodsService } from './api-service/regist-set-plan-promotion-goods.service';
import { PlanGoodsLockService } from '../../../../../src/app/commons/kymw00/api-services/plan-goods-lock.service';

/**
 * セット企画設定画面 モジュール設定クラス
 *
 * @export KYMW1312Module
 * @class KYMW1312Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    KYMW1313Module,
  ],
  declarations: [
    KYMW1312Component,
  ],
  providers: [
    GetSetPlanGoodsInfoService,
    GetSetPlanPromotionGoodsInfoService,
    GetSetPromotionNoService,
    RegistSetPlanPromotionGoodsService,
    PlanGoodsLockService,
  ],
})
export class KYMW1312Module {

}
